export enum AttachmentsListViewTypes {
  List,
  Board,
}
